import { Institution } from "../../entities/institution/institution.model";
import { ProfileTypeString } from "../../modules/profile/store/profile.entity";

interface InstitutionSurveyEventName {
    [ProfileTypeString.DOCTOR]: string;
    [ProfileTypeString.PATIENT]: string;
}

export const WORKSPACE_KEY = '4349004a3e5d846afa6b9dd246edb5f3';

const PATIENTUS_DOCTOR_SURVEY = 'patientus_doctor_survey';
const PATIENTUS_PATIENT_SURVEY = 'patientus_patient_survey';
const UKSH_PATIENT_SURVEY = 'uksh_patient_survey';
const AGAPLESION_PATIENT_SURVEY = 'agaplesion_patient_survey';
const HELIOS_PATIENT_SURVEY = 'helios_patient_survey';
const CFG_AOK_PATIENT_SURVEY = 'cfg_aok_patient_survey';
const CFG_AOK_DOCTOR_SURVEY = 'cfg_aok_doctor_survey';

export const PATIENTUS_FEEDBACK_SURVEY = 'patientus_feedback_survey';

export const institutionToSurveyEventName: Partial<Record<Institution, InstitutionSurveyEventName>> = {
    [Institution.PATIENTUS]: {
        [ProfileTypeString.DOCTOR]: PATIENTUS_DOCTOR_SURVEY,
        [ProfileTypeString.PATIENT]: PATIENTUS_PATIENT_SURVEY
    },
    [Institution.CFG_AOK]: {
        [ProfileTypeString.DOCTOR]: CFG_AOK_DOCTOR_SURVEY,
        [ProfileTypeString.PATIENT]: CFG_AOK_PATIENT_SURVEY
    },
    [Institution.HELIOS]: {
        [ProfileTypeString.DOCTOR]: PATIENTUS_DOCTOR_SURVEY,
        [ProfileTypeString.PATIENT]: HELIOS_PATIENT_SURVEY
    },
    [Institution.AGAPLESION]: {
        [ProfileTypeString.DOCTOR]: PATIENTUS_DOCTOR_SURVEY,
        [ProfileTypeString.PATIENT]: AGAPLESION_PATIENT_SURVEY
    },
    [Institution.UKSH]: {
        [ProfileTypeString.DOCTOR]: PATIENTUS_DOCTOR_SURVEY,
        [ProfileTypeString.PATIENT]: UKSH_PATIENT_SURVEY
    }
};
